/* tslint:disable:jsx-no-lambda */
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from '@module/shared/routerCompat';

import { DataGrid, MUIButton, MUIChip, MUIDialog, Pagination, Title } from '@abb/arcadia-ui-react';
import { SORT_STATE } from '@module/shared/commonTypes';
import { IUserFilterProps, UserFilter } from '@module/userManagement';
import { IConnectedComponent } from '../../reducers';
import { UserDataService } from '../../services/userDataService';
import { IUser, IUserFilterValue, User } from './models';
import { ISearchState, IUserSearchProps } from './reducers';
import { UserModal } from './userModal';

import './userManagement.scss';

export interface IUserManagementState extends ISearchState {
  UserModalForm: IUser;
  UserList: IUser[];
  CurrentUserList?: IUser[];
  filteredList: IUser[];
  showUserModal: boolean;
  showDeleteUserWarningModal: boolean;
  showFilter: boolean;
  totalItemCount: number;
  userToDelete: number;
}

class UserManagementComponent extends React.Component<IUserSearchProps & IConnectedComponent, IUserManagementState> {

  constructor(props: any) {
    super(props);

    this.state = {
      UserModalForm: new User(),
      UserList: [],
      CurrentUserList: undefined,
      filteredList: [],
      showUserModal: false,
      showDeleteUserWarningModal: false,
      showFilter: false,
      totalItemCount: 0,
      userToDelete: 0
    };
  }

  render() {
    let page = (
      <div>
        <h3>Not Authorized</h3>
        <p>{this.props.userPermissions.email} is not an authorized user. Please contact your supervisor to correct this.</p>
      </div>
    );

    // Create list of pills
    const pillList: React.JSX.Element[] = [];

    if (this.props.filter) {
      if (this.props.filter.isAdmin !== undefined) {
        const pillKey = 'Admin Status';
        const lacct = (this.props.filter.isAdmin ? 'Admin' : 'Non-Admin');
        pillList.push(<MUIChip key={pillKey} size={24} label={'Admin Status: ' + lacct} closable={true} handleCloseClick={() => this.onClosePill(pillKey)} handleChipClick={() => this.onClickPill(pillKey)} />);
      }

      if (this.props.filter.email && this.props.filter.email.length > 0) {
        const pillKey = 'email';
        pillList.push(<MUIChip key={pillKey} size={24} label={'Email: ' + this.props.filter.email} closable={true} handleCloseClick={() => this.onClosePill(pillKey)} handleChipClick={() => this.onClickPill(pillKey)} />);
      }

      if (!this.props.filter.allScopes && this.props.filter.scopes && this.props.filter.scopes.length > 0) {
        const pillKey = 'scopes';
        pillList.push(<MUIChip key={pillKey} size={24} label={'Scopes: ' + this.renderScopePill(this.props.filter.scopes)} closable={true} handleCloseClick={() => this.onClosePill(pillKey)} handleChipClick={() => this.onClickPill(pillKey)} />);
      }

      if (this.props.filter.allScopes) {
        const pillKey = 'allScopes';
        pillList.push(<MUIChip key={pillKey} size={24} label={'Scopes: Scoped to all countries'} closable={true} handleCloseClick={() => this.onClosePill(pillKey)} handleChipClick={() => this.onClickPill(pillKey)} />);
      }
    }

    if (this.props.userPermissions.isAdmin) {
      page = (
        <div className='container app-content-div'>
          <div className='row'>
            <div className='col-md-12'>

              <div className='row toolbar'>
                <Title textElement={<div className="title">User Management</div>} />
                <div className='col-md-4'>
                  <div className='text-right'>
                    <MUIButton variant='primary' label="Create New" size={32} iconName='icon_abb_dias icon-abb_add' onClickButton={() => this.handleToggleUserModal()} />{' '}
                  </div>
                </div>
              </div>

              <div className='row'>
                <div className='col-md-12'>
                  <div className='pill-box'>
                    {pillList}
                  </div>
                </div>
              </div>

              <div className='row'>
                <div className='col-md-12 card-container'>
                  <div className='user-table-header'>
                    <h3>Users</h3>
                    <span onClick={(e: any) => e.nativeEvent.stopImmediatePropagation()} onKeyDown={(e: any) => e.nativeEvent.stopImmediatePropagation()}>
                      <MUIButton variant={this.state.showFilter ? 'primary' : 'secondary'} size={32} iconName='icon_abb_dias icon-abb_filter-3' onClickButton={() => this.setState((prevState: any) => ({ showFilter: !prevState.showFilter }))} />
                    </span>
                  </div>
                  {this.state.showFilter ? this.renderFilter() : null}
                  <div className='sites-table-wrapper'>
                    <div className='sites-table-scroll'>
                      {this.renderUserTable()}
                    </div>
                    <div className='sites-pagination'>
                      <Pagination
                        count={this.state.filteredList.length}
                        rowsPerPage={this.props.display || 10}
                        page={Math.floor(this.props.skip / (this.props.display || 10))}
                        handleChangePage={(event: any, page: number) => this.changePage(page * (this.props.display || 10))}
                        handleChangeRowsPerPage={(event: any) => {
                          const newRowsPerPage = Number(event.target.value);
                          const dispatch = this.props.dispatch;
                          dispatch({ type: 'USER_ROWS_PER_PAGE_UPDATE', display: newRowsPerPage });
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {this.state.showDeleteUserWarningModal ? this.renderDeleteUserWarningModal() : null}
          {this.state.showUserModal ? this.renderUserModal() : null}
        </div>
      );
    }

    return (
      page
    );
  }

  renderFilter() {
    return (
      <div className='userFilter' id='userFilter' onClick={this.stopEventPropogation} onKeyDown={(e: any) => e.nativeEvent.stopImmediatePropagation()} >
        <UserFilter
          filter={this.props.filter}
          onFilterApply={this.handleApply}
          onClear={this.handleClear}
        />
      </div>
    );
  }

  renderScopes(user: IUser) {
    let returnString: string = '';
    if (user.allScopes) {
      returnString = 'Scoped to all countries';
    } else {
      if (user.scopes) {
        user.scopes.forEach((s, index) => {
        if (index === 0) {
          returnString = s;
        } else {
          returnString = returnString + ', ' + s;
        }
        });
      }
    }
    return returnString;
  }

  renderScopePill(scopes: string[]) {
    let returnString: string = '';
    if (scopes) {
      scopes.forEach((s, index) => {
      if (index === 0) {
        returnString = s;
      } else {
        returnString = returnString + ', ' + s;
      }
      });
    }
    return returnString;
  }

  renderDeleteUserWarningModal() {
    const warningContent = (
      <div>
        <p>Are you sure you want to DELETE the User?</p>
        <p>This action cannot be undone.</p>
        <div className='user-modal-footer'>
          <MUIButton
            variant='discreet' size={32}
            iconName='icon_abb_dias icon-abb_cancel-1'
            label='Cancel'
            onClickButton={this.toggleDeleteUserWarningModal}
          />
          <MUIButton
            variant='error' size={32}
            iconName='icon_abb_dias icon-abb_delete'
            label='Delete'
            onClickButton={this.handleDelete}
          />
        </div>
      </div>
    );
    return (
      <MUIDialog
        variant='warning'
        open={this.state.showDeleteUserWarningModal}
        heading='DELETE USER'
        content={warningContent}
        parentClassName='userModalDialog'
        onClose={this.toggleDeleteUserWarningModal}
      />
    );
  }

  renderUserTable() {
    const users = this.state.CurrentUserList || [];
    const headerData = [
      { id: 'email', label: 'Email Address', numeric: false, actions: false, enableSort: true },
      { id: 'isAdmin', label: 'Admin Status', numeric: false, actions: false, enableSort: true },
      { id: 'scopes', label: 'Scopes', numeric: false, actions: false, enableSort: true }
    ];
    const rows = users.map((user: IUser) => ({
      id: String(user.id),
      email: user.email,
      isAdmin: user.isAdmin ? 'Admin' : 'Non-Admin',
      scopes: this.renderScopes(user)
    }));
    return (
      <DataGrid
        name='user-management'
        size={40}
        enableCheckbox={false}
        rowsPerPage={rows.length || 1}
        headerData={headerData}
        rows={rows}
        handleClickRow={(row: any) => {
          const selected = (this.state.CurrentUserList || []).find((u: IUser) => String(u.id) === String(row.id));
          if (selected) { this.handleToggleUserModal(selected); }
        }}
        onSortChange={(sort: { column: string; direction: 'asc' | 'desc' }) => this.sortColumn(sort.column)}
      />
    );
  }

  renderUserModal() {
    return (
      <UserModal
        user={this.state.UserModalForm}
        isOpen={this.state.showUserModal}
        onClose={this.handleToggleUserModal}
        onCreate={this.handleCreate}
        onUpdate={this.handleUpdate}
        onDelete={this.toggleDeleteUserWarningModal}
      />
    );
  }

  componentDidMount() {
    // This code is so we close the user filter when we click anywhere that's not inside the filter.
    window.addEventListener('click', this.dismissFilter);

    if (this.props.loggedInUser) {
      this.getUsers();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.dismissFilter);
  }

  componentWillReceiveProps(nextProps: IUserSearchProps) {
    if (!this.props.loggedInUser && (nextProps as any).loggedInUser) {
      this.getUsers();
    }
    if (nextProps.skip !== this.props.skip || nextProps.display !== this.props.display) {
      this.setState((prevState: any) => ({ CurrentUserList: prevState.filteredList.slice(nextProps.skip, nextProps.display + nextProps.skip) }));
    }
    if (nextProps.filter !== this.props.filter) {
      this.filterUsers(this.state.UserList, nextProps.filter);
    }
  }

  getUsers = async () => {
      const users = await UserDataService.getUsers(this.props.loggedInUser);
      this.setState({ UserList: users, totalItemCount: users.length, filteredList: users });
      this.filterUsers(users, this.props.filter);
  }

  onClickPill = (pillKey: string) => {
    // Do Nothing
  }

  onClosePill = (pillKey: string) => {
    const newFilter = { ...this.props.filter };

    if (pillKey === 'Admin Status') {
      newFilter.isAdmin = undefined;
    } else {
      newFilter[pillKey] = '';
    }

    this.handleApply(newFilter);
  }

  stopEventPropogation = (e: React.MouseEvent<HTMLDivElement>) => {
    e.nativeEvent.stopImmediatePropagation();
  }

  handleApply = (filter: IUserFilterValue) => {
    const dispatch = this.props.dispatch;
    dispatch({ type: 'USER_FILTER_UPDATE', filter });
  }

  handleClear = () => {
    const dispatch = this.props.dispatch;
    dispatch({ type: 'USER_CLEAR' });
  }

  changePage = (newSkip: number) => {
    const dispatch = this.props.dispatch;
    dispatch({ type: 'USER_PAGING_UPDATE', skip: newSkip });
  }

  updateTableData = (tablePackageList: IUser[], skip: number) => {
    const display = this.props.display;
    this.setState({ CurrentUserList: tablePackageList.slice(skip, display + skip), filteredList: tablePackageList });
  }

  toggleFilter = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.nativeEvent.stopImmediatePropagation();
    this.setState((prevState: any) => ({ showFilter: !prevState.showFilter }));
  }

  dismissFilter = () => {
    this.setState({ showFilter: false });
  }

  handleToggleUserModal = (user: IUser = new User()) => {
    this.setState({ UserModalForm: user,  userToDelete: user.id }, this.toggleUserModal);
  }

  toggleUserModal = () => {
    this.setState((prevState: any) => ({ showUserModal: !prevState.showUserModal }));
  }

  toggleDeleteUserWarningModal = () => {
    this.setState((prevState: any) => ({ showDeleteUserWarningModal : !prevState.showDeleteUserWarningModal }));
  }

  handleCreate = async (user: IUser) => {
    try {
      await UserDataService.createUser(user, this.props.loggedInUser);
      this.getUsers();
      return true;
    } catch (error) {
      console.error('Failed to create user', error);
      return false;
    }
  }

  handleUpdate = async (user: IUser) => {
    try {
      await UserDataService.updateUser(user, this.props.loggedInUser);
      this.getUsers();
      return true;
    } catch (error) {
      console.error('Failed to update user', error);
      return false;
    }
  }

  handleDelete = async () => {
    try {
      await UserDataService.deleteUser(this.state.userToDelete, this.props.loggedInUser);
      this.getUsers();
      this.toggleDeleteUserWarningModal();
      this.toggleUserModal();
    } catch (error) {
      console.error('User delete failed', error);
    }
  }

  filterUsers = (users: IUser[] | undefined, filter: IUserFilterValue) => {
    if (users !== undefined && filter !== undefined) {
      let newUsersList = users;
      if (filter.email !== undefined) {
        const userEmail = filter.email.toLowerCase();
        newUsersList = newUsersList.filter(user => user.email.toLowerCase().includes(userEmail));
      }
      if (filter.email !== undefined) {
        const userFirstName = filter.email.toLowerCase();
        newUsersList = newUsersList.filter(user => user.email.toLowerCase().includes(userFirstName));
      }
      if (filter.scopes !== undefined) {
        newUsersList = filter.scopes.length === 0 ? newUsersList : newUsersList.filter(user => filter.scopes.every(s => user.allScopes || (user.scopes.includes(s))));
      }
      if (filter.isAdmin !== undefined) {
        if (filter.isAdmin) {
          const userTrue = filter.isAdmin.toString();
          newUsersList = newUsersList.filter(user => user.isAdmin!.toString().includes(userTrue));
        }
        if (!filter.isAdmin) {
          const userFalse = filter.isAdmin.toString();
          newUsersList = newUsersList.filter(user => user.isAdmin!.toString().includes(userFalse));
        }
      }
      if (filter.allScopes) {
        const allScopesTrue = filter.allScopes.toString();
        newUsersList = newUsersList.filter(user => user.allScopes!.toString().includes(allScopesTrue));
      }
      const sortedUsers = this.sortData(this.props.sortField, this.props.sortDirection, newUsersList);
      this.updateTableData(sortedUsers, this.props.skip);
    }
  }

  sortData = (sortByField: string, sortDir: string, unsortedList: IUser[]): IUser[] => {
    const rows = unsortedList.slice();
    rows.sort((a: IUser, b: IUser) => {
      let sortVal = 0;

      if (!a[sortByField] && !b[sortByField]) {
        sortVal = 1;
      } else if (!a[sortByField] || a[sortByField] === undefined) {
        sortVal = -1;
      } else if (!b[sortByField] || b[sortByField] === undefined) {
        sortVal = 1;
      } else {
        if (a[sortByField].toString().toLowerCase() > b[sortByField].toString().toLowerCase()) {
          sortVal = 1;
        }
        if (a[sortByField].toString().toLowerCase() < b[sortByField].toString().toLowerCase()) {
          sortVal = -1;
        }
      }
      if (sortDir === 'desc') {
        sortVal = sortVal * -1;
      }
      return sortVal;
    });
    return rows;

  }

  sortColumn = (sortByFieldName: string) => {
    let sortField: string = this.props.sortField;
    let sortDirection: SORT_STATE;
    if (sortByFieldName) {
      if (this.props.sortField === sortByFieldName) {
        sortDirection = this.toggleSortDirection(this.props.sortDirection);
      } else {
        sortField = sortByFieldName;
        sortDirection = 'asc';
      }
      const dispatch = this.props.dispatch;
      dispatch({ type: 'USER_SORT_UPDATE', sortField, sortDirection });
    }
  }

  toggleSortDirection = (currentDirection: SORT_STATE) => {
    if (currentDirection === 'asc') {
      return 'desc';
    } else {
      return 'asc';
    }
  }
}

export const UserManagement = withRouter(connect<{}, {}, IUserFilterProps & IUserSearchProps & IConnectedComponent>(mapStateToProps)(UserManagementComponent));

function mapStateToProps(store: any) {
  return {
    loggedInUser: store.userState.loggedInUser,
    userPermissions: store.userState.userPermissions,
    filter: store.userFilter.filter,
    skip: store.userFilter.skip,
    display: store.userFilter.display,
    sortDirection: store.userFilter.sortDirection,
    sortField: store.userFilter.sortField
  };
}
